import React from 'react';

interface GuideOptionCardProps {
  option: Record<string, unknown>;
  onSelect: (option: Record<string, unknown>) => void;
  disabled?: boolean;
}

export function GuideOptionCard({ option, onSelect, disabled }: GuideOptionCardProps) {
  const label = String(option.label || "");
  const description = option.description ? String(option.description) : undefined;
  const image = option.image ? String(option.image) : undefined;

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onSelect(option)}
      className="w-full flex items-center gap-4 px-6 py-6 rounded-lg text-left transition-colors"
      style={{
        border: '1px solid var(--color-border)',
        background: 'var(--color-background)',
        fontFamily: 'var(--font-body)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
      onMouseEnter={(e) => {
        if (!disabled) (e.currentTarget.style.borderColor = 'var(--color-primary)');
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--color-border)';
      }}
    >
      {image && (
        <img
          src={image}
          alt=""
          className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          style={{ background: '#f1f5f9' }}
        />
      )}
      <div className="flex flex-col min-w-0">
        <span className="ww-type-body-md font-semibold" style={{ color: 'var(--text-secondary)' }}>
          {label}
        </span>
        {description && (
          <span className="ww-type-body-sm" style={{ color: 'var(--text-tertiary)' }}>
            {description}
          </span>
        )}
      </div>
    </button>
  );
}
